import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { svgSprite, Tooltip } from '../../wrappers';
import { t } from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';
import css from './OfficeConditionBlock.module.scss';
import classnames from 'classnames';
import { generateUniqueId } from '../../../common/utils/utils';

const OfficeConditionBlock = ({ data, key }) => {
    const { translation } = useContext(LangContext) || {};
    return (
        <div key={key}>
            {!!data?.description && (
                <div className={css.descriptionWrap}>
                    <p className={classnames(css.smallOuput, css.smallColor)} key={generateUniqueId()}>
                        {data?.description}{' '}
                    </p>
                    {!!data.tooltipContent && (
                        <div className={css.tooltipWrap}>
                            <Tooltip text={data.tooltipContent} place='top'>
                                {svgSprite('info-circle', {
                                    className: css.speedHeaderTitleTooltipSvg
                                })}
                            </Tooltip>
                        </div>
                    )}
                </div>
            )}
            {data?.items?.map((el, i) => (
                <div key={i} className={classnames(css.conditionBlock, data.status && css.conditionBlockSuccess)}>
                    <div className={css.checkSvgWrap}>
                        {svgSprite(el.status ? 'check-gt' : 'dot', {
                            className: classnames(css.orderStatusPayButtonIcon, el.status ? css.iconGreenSvg : css.iconRedSvg)
                        })}
                        <p className={css.conditionBlockText} key={generateUniqueId()}>
                            {el?.text}
                        </p>
                    </div>
                    {!!data?.statusDone && (
                        <div className={css.statusDone}>
                            <p style={{ color: 'var(--darkColor)' }} key={generateUniqueId()}>
                                {data?.statusDone.has +
                                    ' ' +
                                    t('of', 'из', 'all', translation) +
                                    ' ' +
                                    data?.statusDone.necessary}
                            </p>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
OfficeConditionBlock.propTypes = {
    key: PropTypes.string,
    data: PropTypes.object
};
export default OfficeConditionBlock;
